import { PageHeader } from '@/components/PageHeader';
import { Card, SectionHeader } from '@/components/ui';
import { Video, Plus, Calendar } from 'lucide-react';

export function ReviewPage() {
    return (
        <div className="space-y-6 pb-4">
            <PageHeader title="Video Notes" subtitle="Review and annotate your footage" />

            <div className="px-4 space-y-6">
                <SectionHeader
                    title="Entries"
                    subtitle="Analyze your performance"
                    action={
                        <button className="w-10 h-10 rounded-xl bg-gold-500 text-bg-900 flex items-center justify-center active:scale-95 transition-all shadow-lg shadow-gold-500/20">
                            <Plus className="w-6 h-6" />
                        </button>
                    }
                />

                <div className="space-y-4">
                    {/* Placeholder Entry */}
                    <Card className="group animate-fade-in-up stagger-1">
                        <div className="flex gap-4">
                            <div className="relative w-24 h-16 rounded-lg bg-bg-900 border border-white/5 flex items-center justify-center group-hover:border-gold-500/30 transition-colors overflow-hidden">
                                <div className="absolute inset-0 bg-gradient-to-tr from-gold-500/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                                <Video className="w-6 h-6 text-text-muted group-hover:text-gold-500 transition-colors" />
                            </div>
                            <div className="flex-1 min-w-0">
                                <h3 className="text-text-primary group-hover:text-white transition-colors">Shadow Single Legs</h3>
                                <div className="flex items-center gap-3 mt-1.5">
                                    <div className="flex items-center gap-1 text-[10px] text-text-muted font-bold uppercase tracking-wider">
                                        <Calendar className="w-3 h-3" />
                                        <span>Feb 15</span>
                                    </div>
                                    <div className="w-1 h-1 rounded-full bg-white/10" />
                                    <span className="text-[10px] text-gold-500 font-bold uppercase tracking-wider">3 Notes</span>
                                </div>
                            </div>
                        </div>
                    </Card>

                    {/* Empty State Example (Hidden if there are entries) */}
                    {/* <EmptyState 
                        icon={<Video className="w-8 h-8" />}
                        title="No video notes yet"
                        subtitle="Upload footage from your drills to start analyzing"
                        action={{
                            label: "Upload Film",
                            onClick: () => {}
                        }}
                    /> */}
                </div>
            </div>
        </div>
    );
}
